/* eslint-disable */
<template>
  <div id="learner-table-container">
    <LearnerTableToolbar></LearnerTableToolbar>
    <LearnerTable ></LearnerTable>
    <LearnerTablePagination></LearnerTablePagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LearnerTable from './LearnerTableComponent';
import LearnerTableToolbar from './LearnerTableToolbar';
import LearnerTablePagination from './LearnerTablePagination';

export default {
  name: 'learner-table-container',
  components: {
    LearnerTable,
    LearnerTablePagination,
    LearnerTableToolbar
  },
  data() {
    return {
    };
  },
  computed: {
  ...mapGetters([
    'activeView'
  ]),
  ...mapGetters('learners',[

  ]),
  },
  methods:{
  ...mapActions([
  ])
  },
  watch: {
  },
  mounted() {
  }
};
</script>

<style scoped>
#learner-table-container {
  width: 100%;
  height: 100%;
}
</style>
